import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { v_DispatchBus } from '../../shared/models/v_DispatchBus';
import { v_DispatchAttachmentBus } from '../../shared/models/v_DispatchAttachmentBus';
import { DispatchesService } from '../../shared/services/dispatches.service';

@Component({
  selector: 'workorder-photos',
  templateUrl: './workorder-photos.component.html',
  styleUrls: ['./workorder-photos.component.scss']
})
export class WorkOrderPhotosComponent implements OnInit {
  constructor(private svc_data: DispatchesService) {

  }

  @Input()
  data: v_DispatchBus;

  dataItem: v_DispatchAttachmentBus;

  dataLoading: boolean = false;
//  gridData: v_DispatchBus[];
  ngOnInit() {
    this.getData();
  }

  getData() {
    //this.dataLoading = true;
    //this.svc_data.getByCustomer(this.baseurl + "GetByCustomer/", this.customerId, this.openStatusesOnly).subscribe(data => {
    //  this.data = data;
    //  this.gridData = data;
    //  this.dataLoading = false;
    //});
  }
  view(data: v_DispatchAttachmentBus) {

  }
  hide() {
    this.selectedImage = null;
  }
  selectedImage: any;
  selected: boolean = false;
  setSelectedImage(image) {
    this.selectedImage = image;
  }
}

